import React from 'react';

import GraphqlProvider from './graphqlProvider';
import Root from '../../../StyledComponents/Root';
import SettingsProvider from '../State/Settings/SettingsProvider';
import RelatedSearchProvider from '../State/RelatedSearch/RelatedSearchProvider';
import CentralStorageProvider from '../State/CentralStorage/CentralStorageProvider';

export interface EcomSettings {
  url: string;
  useBankId?: boolean;
  displayBankIdAlert?: boolean;
  serviceLogotypeUrl?: string;
  bankIdThumbprint?: string;
}

export interface WaykeItemProviderSettings {
  url: string;
  urlMlt?: string;
  graphQlUrl: string;
  apiKey?: string;
  ecomSettings?: EcomSettings;
  googleMapsApiKey?: string;
  googleMapsMarker?: string;
}

export type WaykeItemProviderProps = WaykeItemProviderSettings & {
  children?: React.ReactNode;
};

const WaykeItemProvider = ({
  url,
  urlMlt,
  apiKey,
  ecomSettings,
  graphQlUrl,
  googleMapsApiKey,
  googleMapsMarker,
  children,
}: WaykeItemProviderProps) => {
  return (
    <SettingsProvider
      googleMapsApiKey={googleMapsApiKey}
      googleMapsMarker={googleMapsMarker}
      ecomSettings={ecomSettings}
    >
      <CentralStorageProvider>
        <GraphqlProvider uri={graphQlUrl}>
          <RelatedSearchProvider url={url} urlMlt={urlMlt} apiKey={apiKey}>
            <Root>{children}</Root>
          </RelatedSearchProvider>
        </GraphqlProvider>
      </CentralStorageProvider>
    </SettingsProvider>
  );
};

export default WaykeItemProvider;
